module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('topnav', {
    attrs: {
      "keywords": _vm.keyword,
      "toptype": _vm.toptype,
      "isSearch": _vm.path,
      "types": "4"
    },
    on: {
      "tosearch": _vm.tosearch
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "min-height": "600px"
    }
  }, [(_vm.config) ? _c('div', {}, [_c('el-image', {
    staticClass: "topimg",
    attrs: {
      "src": _vm._f("addurl")(_vm.config.zlfw_pic),
      "fit": "fill"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.lease_list.length) ? _c('div', {
    staticClass: "response bggray"
  }, [_c('div', {
    staticClass: "marginauto comswidth"
  }, [_c('div', {
    staticClass: "flex justify-between align-center flex-wrap"
  }, _vm._l((_vm.lease_list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "slideInLeft animated pointer",
      on: {
        "click": function($event) {
          return _vm.todetail(item.id)
        }
      }
    }, [_c('div', {
      staticClass: "hvr-float lone"
    }, [_c('div', {
      staticClass: "line"
    }), _vm._v(" "), _c('div', {
      staticClass: "\n                                    lcon\n                                    flex\n                                    justify-between\n                                    align-center\n                                "
    }, [_c('div', {
      staticClass: "flex-sub",
      staticStyle: {
        "min-height": "161px"
      }
    }, [_c('div', {
      staticClass: "text-cut text-center",
      staticStyle: {
        "width": "100%",
        "font-size": "24px"
      }
    }, [_vm._v("\n                                        " + _vm._s(item.title ? item.title : "") + "\n                                    ")]), _vm._v(" "), _c('div', {
      staticClass: "\n                                            flex\n                                            justify-between\n                                            align-center\n                                        ",
      staticStyle: {
        "padding-top": "20px"
      }
    }, [_c('div', {
      staticClass: "text-center text-cut",
      staticStyle: {
        "width": "25%"
      }
    }, [_c('div', {
      staticStyle: {
        "color": "#ffa10e",
        "font-size": "31px",
        "font-weight": "600"
      }
    }, [_vm._v("\n                                                " + _vm._s(item.number) + "\n                                            ")]), _vm._v(" "), _c('div', {}, [_vm._v("房间号")])]), _vm._v(" "), _c('div', {
      staticClass: "text-center text-cut",
      staticStyle: {
        "width": "25%"
      }
    }, [_c('div', {
      staticStyle: {
        "color": "#ffa10e",
        "font-size": "31px",
        "font-weight": "600"
      }
    }, [_vm._v("\n                                                " + _vm._s(item.position)), _c('span', {
      staticStyle: {
        "font-size": "22px",
        "font-weight": "500"
      }
    }, [_vm._v("楼")])]), _vm._v(" "), _c('div', {}, [_vm._v("位置")])]), _vm._v(" "), _c('div', {
      staticClass: "text-center text-cut",
      staticStyle: {
        "width": "25%"
      }
    }, [_c('div', {
      staticStyle: {
        "color": "#ffa10e",
        "font-size": "31px",
        "font-weight": "600"
      }
    }, [_vm._v("\n                                                " + _vm._s(item.work) + "\n                                            ")]), _vm._v(" "), _c('div', {}, [_vm._v("工位数")])]), _vm._v(" "), _c('div', {
      staticClass: "text-center text-cut",
      staticStyle: {
        "width": "25%"
      }
    }, [_c('div', {
      staticStyle: {
        "color": "#ffa10e",
        "font-size": "31px",
        "font-weight": "600"
      }
    }, [_vm._v("\n                                                " + _vm._s(item.area)), _c('span', {
      staticStyle: {
        "font-size": "22px",
        "font-weight": "500"
      }
    }, [_vm._v("㎡")])]), _vm._v(" "), _c('div', {}, [_vm._v("面积")])])]), _vm._v(" "), _c('div', {
      staticClass: "response flex justify-center"
    }, [_c('div', {
      staticClass: "nowbtn pointer",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.shownow(item.id)
        }
      }
    }, [_vm._v("\n                                            立即咨询\n                                        ")])])]), _vm._v(" "), _c('div', {
      staticClass: "detailcss",
      staticStyle: {
        "position": "relative"
      }
    }, [_c('el-image', {
      staticStyle: {
        "width": "226px",
        "height": "161px",
        "display": "block"
      },
      attrs: {
        "src": _vm._f("addurl")(item.image),
        "fit": "fill"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "detailall"
    }, [_vm._v("查看详情")])], 1)])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "text-center response"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "pager-count": _vm.pagerCount,
      "hide-on-single-page": true,
      "page-size": _vm.pagesize,
      "current-page": _vm.currentPage,
      "total": _vm.totalnum
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (!_vm.lease_list.length && !_vm.load) ? _c('div', {}, [_c('el-empty', {
    attrs: {
      "description": "暂无数据"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "咨询",
      "visible": _vm.addcompany
    },
    on: {
      "update:visible": function($event) {
        _vm.addcompany = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "margin": "0 auto"
    }
  }, [_c('el-form', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "model": _vm.cominfo
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名：",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    staticStyle: {
      "max-width": "420px",
      "flex": "1"
    },
    attrs: {
      "placeholder": "请输入",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.cominfo.name),
      callback: function($$v) {
        _vm.$set(_vm.cominfo, "name", $$v)
      },
      expression: "cominfo.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "电话：",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    staticStyle: {
      "max-width": "420px",
      "flex": "1"
    },
    attrs: {
      "placeholder": "请输入",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.cominfo.phone),
      callback: function($$v) {
        _vm.$set(_vm.cominfo, "phone", $$v)
      },
      expression: "cominfo.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "咨询内容：",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    staticStyle: {
      "max-width": "420px",
      "flex": "1"
    },
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "请输入咨询内容",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.cominfo.content),
      callback: function($$v) {
        _vm.$set(_vm.cominfo, "content", $$v)
      },
      expression: "cominfo.content"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "font-size": "18px"
    },
    attrs: {
      "label": "联系电话：",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('div', {
    staticClass: "flex align-center"
  }, [_c('div', {
    staticStyle: {
      "flex": "1",
      "max-width": "420px",
      "font-size": "18px",
      "text-align": "left",
      "margin": "auto"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.config.phone) + "\n                        ")])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center align-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.nowdisabled,
      "type": "primary"
    },
    on: {
      "click": _vm.tosub
    }
  }, [_vm._v("\n                提 交\n            ")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00bfb8e2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/tenancy.vue
// module id = 381
// module chunks = 1